import React, { useState, useEffect, useRef } from 'react';
import { hot } from 'react-hot-loader';
import Button from '../Button/Button';
import { addEvent, removeEvent } from '../../../utils/dom';
import s from './FakeSelect.scss';

const FakeSelect = ({ variantClasses = [], id, options, selected, inputChange = () => {}, openOnLoad = false, type = 'form', disabled = false }) => {
	const [open, toggleOpen] = useState(openOnLoad);
	const [title, updateTitle] = useState(selected);
	const fakeSelectEl = useRef(null);
	const fakeSelectClasses = [s.fakeSelect];
	if (open) fakeSelectClasses.push(s.fakeSelect__open);
	if (disabled) fakeSelectClasses.push(s.fakeSelect__disabled);

	if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('fakeSelect') !== -1) fakeSelectClasses.push(s[c]);
	});

	useEffect(() => {
		const $body = document.querySelector('body');

		addEvent($body, 'click.fakeSelectClose', (e) => {
			if (fakeSelectEl.current && !fakeSelectEl.current.contains(e.target) && open) {
				e.stopPropagation();
				e.preventDefault();
				toggleOpen(false);
			}
		});

		addEvent(window, 'keydown.fakeSelectClose', (e) => {
			if (e.key === 'Escape' && open) toggleOpen(false);
		});

		return () => {
			removeEvent($body, 'click.fakeSelectClose');
			removeEvent(window, 'keydown.fakeSelectClose');
		};
	}, [open]);

	const openSelectHandler = (e) => {
		e.preventDefault();
		toggleOpen((prevState) => !prevState);
	};

	const inputChangeHandler = (e) => {
		const value = type === 'form' ? e.currentTarget.value : e.currentTarget.textContent;
		if (disabled) return;

		inputChange(id, value);
		updateTitle(options.filter((o) => o.key === value)?.[0]?.value);
		toggleOpen(false);
	};

	return (
		<div ref={fakeSelectEl} className={fakeSelectClasses.join(' ')}>
			<a href="#open" onClick={openSelectHandler} className={s.fakeSelect_title}>
				{ title }
				<svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><polyline points="1167 1513 1173 1519 1179 1513" transform="translate(-1166 -1512)" /></svg>
			</a>
			<div className={s.fakeSelect_inner}>
				{
					options.map((option) => (
						<div key={option.key} className={[s.fakeSelect_inner_item, (option.disabled ? s.fakeSelect_inner_item__disabled : null), (option.selected ? s.fakeSelect_inner_item__selected : null)].join(' ')}>
							{
								type === 'form' ? (
									<label htmlFor={option.key}>
										<input id={option.key} className={s.fakeSelect_inner_item_input} onChange={inputChangeHandler} disabled={option.disabled} checked={option.selected} type="radio" name="size" value={option.key} />
										<span>{ option.value }</span>
									</label>
								) : (
									<Button id={option.key} linkStyle type={type} disabled={option.disabled} clickEventHandler={inputChangeHandler} location={option.key} openNewWindow={false}><span>{ option.value }</span></Button>
								)
							}
						</div>
					))
				}
			</div>
		</div>
	);
};

export default hot(module)(FakeSelect);
